module.exports = __webpack_public_path__ + "static/media/not_fav_icon.d3da4137.png";